import React, { Component, PropTypes } from "react";
import { RichUtils, Modifier, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { stateFromHTML } from "draft-js-import-html";
import AddRelatedProducts from "./AddRelatedProducts";
import emojis from "./emoji";
import he from "he";
import { convertFromHTML } from "draft-convert";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const options = {
  htmlToStyle: (nodeName, node, currentStyle) => {
    if (nodeName === "span" && node.style.textDecoration === "underline") {
      return currentStyle.add("UNDERLINE");
    } else {
      return currentStyle;
    }
  },
  htmlToEntity: (nodeName, node, createEntity) => {
    if (nodeName === "a") {
      return createEntity("LINK", "MUTABLE", {
        url: node.href,
        target: node.target
      });
    }
  }
};

class EditorDescription extends Component {
  handleReturn = (e, editorState) => {
    var selection = this.props.editorState.getSelection();
    var content = this.props.editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getAnchorKey());
    this.props.onEditorStateChange(
      RichUtils.insertSoftNewline(this.props.editorState)
    );
    return true;
  };

  handlePastedText = (text, html) => {
    const { editorState } = this.props;
    let textToInput = html;

    if (!html) {
      textToInput = "<span>" + text + "</span>";
    } else {
      textToInput = he.decode(he.decode(html));
    }

    let newHtml = textToInput.replace(/\n/g, "<br />");
    if (html) {
      // html pastes creates a few extra breaklines
      newHtml = newHtml.replace("<br />", "");
      var lastIndex = newHtml.lastIndexOf("<br />")
      if(lastIndex >= 0)
      newHtml = newHtml.substr(0, lastIndex) + newHtml.substr(lastIndex + "<br />".length);
    }
    const blockMap = convertFromHTML(options)(newHtml, true).blockMap;
    const newState = Modifier.replaceWithFragment(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      blockMap
    );
    this.props.onEditorStateChange(
      EditorState.push(editorState, newState, "insert-fragment")
    );
    return true;
  };
  render() {
    const {
      products,
      filterText,
      editorState,
      onEditorStateChange,
      onFilter
    } = this.props;
    return (
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        handleReturn={this.handleReturn}
        handlePastedText={this.handlePastedText}
        toolbar={{
          options: ["inline", "link", "emoji"],
          inline: {
            options: ["bold", "italic", "underline"],
            underline: { className: "bordered-option-classname" },
            bold: { className: "bordered-option-classname" },
            italic: { className: "bordered-option-classname" }
          },
          list: {
            unordered: {
              className: "bordered-option-classname"
            },
            ordered: { className: "bordered-option-classname" }
          },
          emoji: {
            className: undefined,
            component: undefined,
            popupClassName: undefined,
            emojis: emojis()
          }
        }}
        toolbarCustomButtons={[
          <AddRelatedProducts
            filterText={filterText}
            onFilter={onFilter}
            products={products}
          />
        ]}
        onEditorStateChange={onEditorStateChange}
      />
    );
  }
}

export default EditorDescription;



// WEBPACK FOOTER //
// ./src/components/Editor.js